import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Breadcrumb } from 'antd';
import './DmBreadcrumbTypes.js';

var _excluded = ["className"];

/**
 * UI component for manages breadcrumbs. Uses antd Breadcrumb props
 */
var DmBreadcrumb = function DmBreadcrumb(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Breadcrumb, _extends({}, props, {
    className: "dm-breadcrumb ".concat(className)
  }));
};

export { DmBreadcrumb };
